import React, { useState, useMemo } from "react";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { IconButton, Button } from "@material-ui/core";
import yellow from "@material-ui/core/colors/yellow";
import { Link } from "react-router-dom";
import { helpers } from '../../helper/helper';
import DeleteIcon from "@material-ui/icons/Delete";
import DataTable from "react-data-table-component";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import SearchLayoutGender from "../../layouts/SearchLayoutGender";
import VisibilityIcon from "@material-ui/icons/Visibility";
import user from "../../assets/images/faces-clipart/pic-1.png";
import { Edit } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    root: {
        "& > *": {
            margin: theme.spacing(1),
            width: theme.spacing(32),
            height: theme.spacing(16),
        },
    },
    yellowPaper: {
        backgroundColor: yellow[300],
    },
    customBorder: {
        border: `3px solid ${yellow[200]}`,
    },
    customBorderRadius: {
        borderRadius: 10,
    },
}));

const sortIcon = <ArrowDownward />;

const UsersList = ({
    userList,
    deleteGifts,
    BlockUser,
    setOpen,
    open,
    handleClose,
    setOpenBlock,
    openBlock,
    handleCloseBlock,
    skip,
    setSkip,
    limit,
    setLimit,
    filterText,
    setFilterText,
    //    fetchDataOfFilter
}) => {
    const classes = useStyles();
    const [rows, setRows] = useState(userList.result.users);          // current page data
    const totalPages = Math.ceil(userList.result.count / limit);

    const headingAdmin = [
        // {
        //     name: "No",
        //     selector: (row) => row._id,
        //     wrap: true,
        //     sortable: true,
        // },
        {
            name: "Type",
            selector: (row) => row.type,
            wrap: true,
            sortable: true,
        },
        {
            name: "Image",
            wrap: true,
            sortable: true,
            cell: (userList) => (
                <div>
                    <img
                        style={{ width: "60px", height: "60px", borderRadius: "50%" }}
                        src={userList && userList.url ? userList.url : user}
                        alt="Logo"
                    />
                </div>
            ),
        },
        {
            name: "Actions",
            wrap: true,
            center: true,
            cell: (row) => (
                // <div>
                //     <Link to={"/dashboard/users/" + userList._id}>
                //         <VisibilityIcon/>
                //     </Link>
                //     <Link to={`/dashboard/users/update/details/${userList._id}`} className="ml-3">
                //         <Edit/>
                //     </Link>

                //     <IconButton
                //         edge="end"
                //         aria-label="delete"
                //         onClick={() => {
                //             deleteGifts(userList._id);
                //         }}
                //     >
                //         <DeleteIcon color="primary"/>
                //     </IconButton>
                // </div>
                <div style={{ display: "flex", gap: "10px" }}>
                    <IconButton onClick={() => openEditModal(row)}>
                        <Edit />
                    </IconButton>

                    {/* <IconButton onClick={() => handleDelete(row.type, true)}>
                        <DeleteIcon style={{ color: "red" }} />
                    </IconButton> */}
                </div>
            ),
        },
    ];

    const [openEdit, setOpenEdit] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [newType, setNewType] = useState("");
    const [newIsDeleted, setNewIsDeleted] = useState(false);
    const [newLogoFile, setNewLogoFile] = useState(null);
    const [logoPreview, setLogoPreview] = useState(null);

    // OPEN MODAL
    const openEditModal = (item) => {
        setSelectedItem(item);
        setNewType(item.type);
        setNewIsDeleted(item.isDeleted || false);
        setLogoPreview(item.url || null);
        setOpenEdit(true);
    };

    // DELETE HANDLER
    const handleDelete = async (type, isDeleted) => {
        // if (!window.confirm("Are you sure you want to delete this?")) return;

        await deleteGifts(type, isDeleted); // you already have this
    };

    // FILE CHANGE
    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        setNewLogoFile(file);
        setLogoPreview(URL.createObjectURL(file));
    };

    // UPDATE HANDLER (SEND API)
    const handleUpdate = async () => {
        const formData = new FormData();
        formData.append("id", selectedItem._id);
        formData.append("type", newType);
        formData.append("isDeleted", newIsDeleted);

        // if (newLogoFile) 
        formData.append("url", newLogoFile);

        // await fetch("https://your-api.com/claim-type-images", {
        //     method: "POST",
        //     body: formData,
        // });
        const url = `claim-type-images`;
        const result = await helpers.apiCallForm("PUT", url, formData);

        console.log('result', result)
        setOpenEdit(false);

        // refresh list
        window.location.reload();
    };

    console.log('userList.result', userList.result)
    return (
        <>
            <Paper className={classes.customBorderRadius} elevation={15}>
                <DataTable
                    columns={headingAdmin}
                    data={userList.result || []}
                    defaultSortField="createdAt"
                    pagination
                    paginationServer
                    paginationTotalRows={userList.pagination.totalCount}
                    paginationDefaultPage={skip}   // ⭐ VERY IMPORTANT
                    paginationRowsPerPageOptions={[10, 20, 30]}
                    onChangePage={(p) => {
                        console.log('p', p)
                        setSkip(p)
                    }}
                    onChangeRowsPerPage={(newPerPage, p) => {
                        console.log('p', p)
                        setSkip(p)
                        setLimit(newPerPage)
                        console.log('newPerPage', newPerPage)
                    }}
                    sortIcon={sortIcon}
                    // subHeader
                    // subHeaderComponent={subHeader}
                    noHeader={true}
                    // subHeaderWrap={false}
                    // subHeaderAlign="right"
                    // subHeaderComponent={subHeaderComponentMemo}
                    striped={true}
                    highlightOnHover={true}
                    responsive={true}
                />
            </Paper>
            {/* EDIT MODAL */}
            {openEdit && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: "rgba(0,0,0,0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            padding: "25px",
                            width: "450px",
                            borderRadius: "8px",
                        }}
                    >
                        <h3>Edit Claim Type</h3>

                        {/* Type */}
                        <div style={{ marginBottom: "15px" }}>
                            <label>Type</label>
                            <input
                                type="text"
                                value={newType}
                                disabled
                                // onChange={(e) => setNewType(e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            />
                        </div>

                        {/* Image Upload */}
                        <div style={{ marginBottom: "15px" }}>
                            <label>Logo</label>
                            <input type="file" onChange={handleLogoChange} />

                            {logoPreview && (
                                <img
                                    src={logoPreview}
                                    alt="Preview"
                                    style={{
                                        width: "80px",
                                        height: "80px",
                                        marginTop: "10px",
                                        borderRadius: "6px",
                                        objectFit: "cover",
                                        border: "1px solid #ddd",
                                    }}
                                />
                            )}
                        </div>

                        {/* isDeleted Toggle */}
                        {/* <div style={{ marginBottom: "15px" }}>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={newIsDeleted}
                                    onChange={(e) => setNewIsDeleted(e.target.checked)}
                                />
                                <span style={{ marginLeft: "8px" }}>Mark as Deleted</span>
                            </label>
                        </div> */}

                        {/* Buttons */}
                        <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleUpdate}
                            >
                                Update
                            </Button>

                            <Button
                                variant="contained"
                                onClick={() => setOpenEdit(false)}
                            >
                                Cancel
                            </Button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
export default UsersList;
